/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ----- Free Socks for new theme Palo Alto -----
   if( $('.free-socks .free-socks__select').length>0) {
     $('.free-socks .free-socks__select').on('change', function () {
           $(this).parents('form').trigger('submit');
     });
   }
   // Slick Slider for "free socks" in cart page
    $(document).ready(function() {
        $('.free-socks-carousel').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            dots: true,
            responsive: [
              {
                breakpoint: 1024, // Ancho máximo de pantalla
                settings: {
                  slidesToShow: 3, // Cambiar a 3 columnas
                  slidesToScroll: 3
                }
              },
              {
                breakpoint: 768, // Ancho máximo de pantalla
                settings: {
                  slidesToShow: 2, // Cambiar a 2 columnas
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 480, // Ancho máximo de pantalla
                settings: {
                  slidesToShow: 2, // Cambiar a 1 columna
                  slidesToScroll: 2
                }
              }
            ]
        });
    });
    // Remove products from cart page
    $('body').on('click', '.cart__items .cart__item__remove', function (e) {
        e.preventDefault();
        const self = $(this);          
        if (confirm('cart.general.confirm_remove') == true) {               
                if (window.freeSocks != undefined) {
                    let isMenColF = false;
                    let isWomenColF = false;
                    let isMenColS = false;
                    let isWomenColS = false;
                    const index = parseInt($(this).attr('data-line'), 10);
                    const collections = window.freeSocks.cart[index];
    
                    if (collections.includes(window.freeSocks.collections.men.first)) {
                        isMenColF = true;
                    }
                    if (collections.includes(window.freeSocks.collections.women.first)) {
                        isWomenColF = true;
                    }
                    if (collections.includes(window.freeSocks.collections.men.second)) {
                        isMenColS = true;
                    }
                    if (collections.includes(window.freeSocks.collections.women.second)) {
                        isWomenColS = true;
                    }
                    if (isMenColF || isWomenColF || isMenColS || isWomenColS) {
                        let isMenColFN = false;
                        let isWomenColFN = false;
                        let isMenColSN = false;
                        let isWomenColSN = false;
                        for (var i = 0; i < window.freeSocks.cart.length; i++) {
                            if (i != index) {
                                const collectionsN = window.freeSocks.cart[i];
                                if (isMenColF == true && collectionsN.includes(window.freeSocks.collections.men.first)) {
                                    isMenColFN = true;
                                }
                                if (isWomenColF == true && collectionsN.includes(window.freeSocks.collections.women.first)) {
                                    isWomenColFN = true;
                                }
                                if (isMenColS == true && collectionsN.includes(window.freeSocks.collections.men.second)) {
                                    isMenColSN = true;
                                }
                                if (isWomenColS == true && collectionsN.includes(window.freeSocks.collections.women.second)) {
                                    isWomenColSN = true;
                                }
    
                            }
                        }
                        let hasOther = false;
                        if (isMenColF == true && isMenColFN == true) {
                            hasOther = true;
                        }
                        if (isWomenColFN == true && isWomenColF == true) {
                            hasOther = true;
                        }
                        if (isMenColSN == true && isMenColS == true) {
                            hasOther = true;
                        }
                        if (isWomenColSN == true && isWomenColS == true) {
                            hasOther = true;
                        }
    
                        if (hasOther == false) {
                            const parent = $('.cart__items');
                          
                            let data = false;
                            if (isMenColF || isMenColS) {
                                for (var i = 0; i < window.freeSocks.variants.men.length; i++) {
                                    const el = parent.find('.js-is-free[data-variant-id="' + window.freeSocks.variants.men[i] + '"]');
                                    if (el.length > 0) {
                                        const dataId = el.attr('data-variant-id');
                                        data = {
                                            'id': dataId,
                                            'quantity': '0'
                                        };
                                    }
                                }
                            }
                            if (isWomenColF || isWomenColS) {
                                for (var i = 0; i < window.freeSocks.variants.women.length; i++) {
                                    const el = parent.find('.js-is-free[data-variant-id="' + window.freeSocks.variants.women[i] + '"]');
                                    if (el.length > 0) {
                                        const dataId = el.attr('data-variant-id');
                                        data = {
                                            'id': dataId,
                                            'quantity': '0'
                                        };
                                    }
                                }
                            }
                            if (data == false) {
                                window.location.href = $(this).attr('href');
                            } else {
                                fetch('/cart/change.js', {
                                    body: JSON.stringify(data),
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'xmlhttprequest'
                                    },
                                    method: 'POST'
                                }).then(function (response) {
                                    console.log(response);
                                    return response.json();
                                }).then(function (json) {                                    
                                    // window.location.href = self.attr('href');
                                    // window.location.href = "/cart";
                                  parent.find('.js-is-free[data-variant-id="' + data.id + '"]').closest('.cart__item').remove();
                                  
                                }).catch(function (err) {
                                    console.error(err);
                                    window.location.href = self.attr('href');
                                });
                            }
                        } 
                        else { //comentado porque lo que hace es recargar al elemnto que se borro por ajax y da error, no funciona con este tema
                            // console.log("HOLA 1");
                        }
                    }
                    else {
                      // console.log("HOLA 2");
                      // Verificar si el elemento clickeado tiene la clase js-is-free
                        if ($(self).closest('.js-is-free').length > 0) {
                            window.location.reload(); // Recargar la página del carrito si tiene la clase .js-is-free
                        } 
                    }
    
                } 
                else {    //comentado porque lo que hace es recargar al elemnto que se borro por ajax y da error, no funciona con este tema
                    // window.location.href = self.attr('href');
                  // console.log("HOLA 3");
                }
            }
        
    });
  // Remove products from cart drawer
    $('body').on('click', '.cart-drawer__items .cart__item__remove', function (e) {
        e.preventDefault();
        const self = $(this);
        // console.log("desde el drawer");          
        if (confirm('cart.general.confirm_remove') == true) { 
              
                if (window.freeSocks != undefined) {
                    let isMenColF = false;
                    let isWomenColF = false;
                    let isMenColS = false;
                    let isWomenColS = false;
                    const index = parseInt($(this).attr('data-line'), 10);
                    const collections = window.freeSocks.cart[index];
    
                    if (collections.includes(window.freeSocks.collections.men.first)) {
                        isMenColF = true;
                    }
                    if (collections.includes(window.freeSocks.collections.women.first)) {
                        isWomenColF = true;
                    }
                    if (collections.includes(window.freeSocks.collections.men.second)) {
                        isMenColS = true;
                    }
                    if (collections.includes(window.freeSocks.collections.women.second)) {
                        isWomenColS = true;
                    }
                    if (isMenColF || isWomenColF || isMenColS || isWomenColS) {
                        let isMenColFN = false;
                        let isWomenColFN = false;
                        let isMenColSN = false;
                        let isWomenColSN = false;
                        for (var i = 0; i < window.freeSocks.cart.length; i++) {
                            if (i != index) {
                                const collectionsN = window.freeSocks.cart[i];
                                if (isMenColF == true && collectionsN.includes(window.freeSocks.collections.men.first)) {
                                    isMenColFN = true;
                                }
                                if (isWomenColF == true && collectionsN.includes(window.freeSocks.collections.women.first)) {
                                    isWomenColFN = true;
                                }
                                if (isMenColS == true && collectionsN.includes(window.freeSocks.collections.men.second)) {
                                    isMenColSN = true;
                                }
                                if (isWomenColS == true && collectionsN.includes(window.freeSocks.collections.women.second)) {
                                    isWomenColSN = true;
                                }
    
                            }
                        }
                        let hasOther = false;
                        if (isMenColF == true && isMenColFN == true) {
                            hasOther = true;
                        }
                        if (isWomenColFN == true && isWomenColF == true) {
                            hasOther = true;
                        }
                        if (isMenColSN == true && isMenColS == true) {
                            hasOther = true;
                        }
                        if (isWomenColSN == true && isWomenColS == true) {
                            hasOther = true;
                        }
    
                        if (hasOther == false) {
                            const parent = $('.cart-drawer__items');
                          
                            let data = false;
                            if (isMenColF || isMenColS) {
                                for (var i = 0; i < window.freeSocks.variants.men.length; i++) {
                                    const el = parent.find('.js-is-free[data-variant-id="' + window.freeSocks.variants.men[i] + '"]');
                                    if (el.length > 0) {
                                        const dataId = el.attr('data-variant-id');
                                        data = {
                                            'id': dataId,
                                            'quantity': '0'
                                        };
                                    }
                                }
                            }
                            if (isWomenColF || isWomenColS) {
                                for (var i = 0; i < window.freeSocks.variants.women.length; i++) {
                                    const el = parent.find('.js-is-free[data-variant-id="' + window.freeSocks.variants.women[i] + '"]');
                                    if (el.length > 0) {
                                        const dataId = el.attr('data-variant-id');
                                        data = {
                                            'id': dataId,
                                            'quantity': '0'
                                        };
                                    }
                                }
                            }
                            if (data == false) {
                                window.location.href = $(this).attr('href');
                            } else {
                              console.log(data);
                                fetch('/cart/change.js', {
                                    body: JSON.stringify(data),
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'xmlhttprequest'
                                    },
                                    method: 'POST'
                                }).then(function (response) {
                                    // console.log(response);
                                    return response.json();
                                }).then(function (json) {                                    
                                    // window.location.href = self.attr('href');
                                    // window.location.href = "/cart";
                                  parent.find('.js-is-free[data-variant-id="' + data.id + '"]').closest('.cart__item').remove();
                                  
                                }).catch(function (err) {
                                    console.error(err);
                                    // window.location.href = self.attr('href');
                                });
                            }
                        } 
                        else { //comentado porque lo que hace es recargar al elemnto que se borro por ajax y da error, no funciona con este tema
                            // window.location.href = self.attr('href');
                          // console.log("HOLA 1");
                        }
                    }
                    else {
                      // console.log("HOLA 2");
                      // Verificar si el elemento clickeado tiene la clase js-is-free
                        if ($(self).closest('.js-is-free').length > 0) {
                            //window.location.reload(); // Recargar la página del carrito si tiene la clase .js-is-free
                        } 
                    }
    
                } 
                else {    //comentado porque lo que hace es recargar al elemnto que se borro por ajax y da error, no funciona con este tema
                   console.log("HOLA 3");
                  const $clickedElement = $(self);  
                  // Busca el elemento padre más cercano con la clase "cart__item"
                  const $parentElement = $clickedElement.closest(".cart__item");                
                  // Verifica si el elemento padre tiene la clase "collection-bibshorts"
                  if ($parentElement.length && $parentElement.hasClass("js-is-free")) {
                    if(($('.collection-jerseys-men').length > 0 &&  ($('.collection-bibshorts').length > 0) ) || ($('.collection-jerseys-women').length > 0 &&  $('.collection-bib-shorts-women').length > 0)){
                      $('.message-freesocks-cart-drawer').hide();
                    }
                  } else {
                    console.log("El elemento padre no tiene la clase 'js-is-free'.");
                    if($('.js-is-free').length>0){ 
                      console.log("Hay medias en el carrito");

                      if (!(($('.collection-jerseys-men').length > $('.collection-jerseys-men.is-removed').length || $('.collection-jerseys-men.is-removed').length == 0)
                        && ($('.collection-bibshorts').length > $('.collection-bibshorts.is-removed').length || $('.collection-bibshorts.is-removed').length == 0)
                        && ($('.collection-jerseys-women').length > $('.collection-jerseys-women.is-removed').length || $('.collection-jerseys-women.is-removed').length == 0)
                        && ($('.collection-bib-shorts-women').length > $('.collection-bib-shorts-women.is-removed').length || $('.collection-bib-shorts-women.is-removed').length == 0))){
                            // console.log("Jersey men",$('.collection-jerseys-men'));
                            // console.log("BM",$('.collection-bibshorts'));
                            // console.log("JW" ,$('.collection-jerseys-women'));
                            // console.log("BW",$('.collection-bib-shorts-women'));
                            const dataId = $('.js-is-free').attr('data-variant-id');
                            data = {
                                'id': dataId,
                                'quantity': '0'
                            }
                             fetch('/cart/change.js', {
                                body: JSON.stringify(data),
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'xmlhttprequest'
                                },
                                method: 'POST'
                            }).then(function (response) {
                                console.log(response);
                                return response.json();
                            }).then(function (json) {                                 
                               
                                
                                           $('.js-is-free').remove();
                                       $('.message-freesocks-cart-drawer').hide();
                              
                            }).catch(function (err) {
                                console.error(err);
                            });
                        }                             
                        
                    }  
                  }
                }
            }        
    });
  
    // After adding a product to cart check if Messsage for free sock is show
    $(document).ready(function () {
       checkFreeSocksExist();
      // Escuchar el evento de clic en el botón de añadir al carrito
      $('body').on('click', '[data-add-to-cart]', function (e) {
        e.preventDefault();  // Prevenir el comportamiento predeterminado del botón    
        const button = $(this);
        const form = button.closest('form');  // Obtener el formulario más cercano                
       checkForMessageFreeSocks();      
        
      });
    });

    function checkFreeSocksExist(){
      // Obtener el contenido actualizado del carrito
       $.get('/cart', function (data) {
          // console.log('Carrito actualizado:', data);    
          // Crear un contenedor temporal para el HTML de la página de carrito
          var tempDiv = $('<div>').html(data);    
          // Buscar el contenido de Free Socks en el carrito actualizado
          var freeSocks = tempDiv.find('.free-socks-carousel');    
          // Verificar si encontramos la sección de Free Socks
          if (freeSocks.length > 0) {
            $('.cart-drawer').addClass('show-fs-message'); 
          } 
          // else {
          //   console.log('No hay Free Socks en el carrito.');
          // }
        });
    }

    // Función que realiza el polling para buscar el elemento con la clase "message-freesocks-cart-drawer"
    function checkForMessageFreeSocks() {
      var maxTime = 30000; // Tiempo máximo en milisegundos (30 segundos)
      var startTime = Date.now(); // Obtener el tiempo actual
      var interval = setInterval(function () {
        // Verificamos si el elemento con la clase "message-freesocks-cart-drawer" existe en el DOM
        
        if( $('.message-freesocks-cart-drawer').length > 0 ){
          if ( ($('.collection-jerseys-men').length > 0 &&  ($('.collection-bibshorts').length > 0) ) || ($('.collection-jerseys-women').length > 0 &&  $('.collection-bib-shorts-women').length > 0) ){
            console.log('¡Elemento encontrado!');  
            // Detenemos el polling ya que encontramos el elemento
            clearInterval(interval);
             
            $('.cart-drawer').removeClass('show-fs-message');
            if($('.js-is-free').length ==0 ){ console.log("BRB");
              $('.message-freesocks-cart-drawer').show();
               
             }
          }
        }     
        // Comprobar si se ha alcanzado el tiempo máximo (30 segundos)
        if (Date.now() - startTime >= maxTime) {
          // console.log('Tiempo máximo alcanzado, no se encontró el elemento.');  
          // Detener el polling
          clearInterval(interval);                  
        }
      }, 100); // Revisamos cada 100ms, puedes ajustar el intervalo según sea necesario.
    }
  // ----- FIN - Free Socks for new theme Palo Alto -----  


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
